module.exports = __webpack_public_path__ + "static/media/awoolplanet_htu02.bbce7433.gif";